import { ErrorBoundary } from 'react-error-boundary';
import { logError } from "utils/logs";

import Toasts from 'components/library/Toasts';

import './components/library/style/normalize.css';
import './components/library/style/reset.css';
import './components/library/style/typography.css';
import './components/library/style/animations.css';

import RouteConfig from './services/routes/routes';

function App() {
  return (
    <div className="App">
      <ErrorBoundary fallback={<div>Something went wrong.</div>} onError={logError}>
        <RouteConfig />
        <Toasts />
      </ErrorBoundary>
    </div>
  );
}

export default App
